import { FluidContainer } from '../../Utils/styles/display';
import { PeopleDirectoryView } from './Components/PeopleDirectoryView';
import { Loader } from './Components/Loader';
import { SearchPeopleDirectory } from './Components/SearchPeopleDirectory';
import { usePeopleDirectory } from './usePeopleDirectory';
import EmptyErrorStateTemplate from '../../atomic/molecules/EmptyErrorStateTemplate';
import ErrorImage from '../../img/error.svg';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { userActivitiesStore } from '../../stores/userActivitiesStore';

export const PeopleDirectory = () => {
  const {
    data,
    setSearchValue,
    searchedMembers,
    membersSearchValue,
    hasMoreMembersToFetch,
    isMembersSearchLoading,
    isMembersFetchingError,
    fetchMoreInfiniteMembers,
    handleItemClick,
  } = usePeopleDirectory();

  const { pathname } = useLocation();

  const { upsertUserActivity } = userActivitiesStore.getState();

  useEffect(() => {
    upsertUserActivity({
      visitCount: 1,
      type: 'people',
      url: `${pathname}`,
      pageTitle: `People directory`,
      lastVisitedAt: new Date().toISOString(),
      pageDescription: `View all members of your Assembly`,
    });
  }, [pathname, upsertUserActivity]);

  if (isMembersFetchingError) {
    return (
      <FluidContainer contentPadding="16px">
        <EmptyErrorStateTemplate
          image={ErrorImage}
          heading="Error loading People"
          subHeading="Please refresh the page to try again."
        />
      </FluidContainer>
    );
  }

  if (!data.length && isMembersSearchLoading) {
    return <Loader />;
  }
  return (
    <>
      <FluidContainer>
        <>
          <SearchPeopleDirectory setSearchValue={setSearchValue} />
          <PeopleDirectoryView
            isMembersLoading={isMembersSearchLoading}
            hasMoreMembersToFetch={hasMoreMembersToFetch || false}
            fetchMoreInfiniteMembers={fetchMoreInfiniteMembers}
            data={
              membersSearchValue && searchedMembers ? searchedMembers : data
            }
            membersSearchValue={membersSearchValue}
            onItemClick={handleItemClick}
          />
        </>
      </FluidContainer>
    </>
  );
};
